<div id="gestione-ristorante" class=" col-md-12 col-sm-12 col-xs-12 col-lg-12">
    <div class="hidden-sm hidden-xs">
        <h2 style="display: inline-block;white-space: nowrap;">Gestione Ristorante</h2>
        <h2 style="display: inline-block;white-space: nowrap;" *ngIf="globalData.dataSceltaFormatoIta != ''"
            style="float:right">Data:
            {{globalData.dataSceltaFormatoIta}}</h2>
    </div>

    <div class="hidden-lg hidden-md">
        <h2 style="text-align: center">Gestione Ristorante</h2>
        <h2 style="text-align: center" *ngIf="globalData.dataSceltaFormatoIta != ''">Data:
            {{globalData.dataSceltaFormatoIta}}</h2>
    </div>

    <ngbd-datepicker-ita-rist></ngbd-datepicker-ita-rist>


    <button class="btn btn-primary" type="button" style="margin-bottom: 10px; cursor: pointer" data-toggle="modal"
        (click)="modInCorso()" [attr.data-target]="'#addPrenotazioneRistoranteoModal'"> <span
            class="glyphicon glyphicon-plus"></span>
        Aggiungi Prenotazione</button>&nbsp;
    <button class="btn btn-primary" type="button" style="margin-bottom: 10px; cursor: pointer" data-toggle="modal"
        [attr.data-target]="'#dispRistoranteModal'"> <span class="glyphicon glyphicon-edit"> </span> Modifica
        Disponibilità</button><br>
    <div class="row hidden-xs hidden-sm">
        <div class="col-md-2 col-lg-2 col-xs-2 col-sm-2 hidden-xs hidden-sm"></div>
        <div class="col-md-8 col-lg-8 col-xs-12 col-sm-12" style="position:relative">
            <span (click)="toggleAlertNewBookings()" *ngIf="globalData.showAlertNewBookingsRist"
                style="top: 0; right: 0; position: absolute; margin-right: 36px; margin-top: 10px; font-size: 2vh; cursor: pointer;">X</span>
            <alert class="nuoviOrdini" *ngIf="globalData.showAlertNewBookingsRist"
                style="cursor: pointer; width: 800px; height: 600px; font-size: 5.5vh; text-align: center; font-weight: 700; top: 50%; left: 0;"
                (click)="toggleAlertNewBookings()" type="danger">SONO PRESENTI NUOVE PRENOTAZIONI
            </alert>
        </div>
        <div class="col-md-2 col-lg-2 col-xs-2 col-sm-2 hidden-xs hidden-sm"> </div>


        <!-- Pannello Fascia Oraria: PRANZO -->
        <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h3 class="panel-title text-center" style="color: white"> PRANZO - Coperti totali:
                        {{this.globalData.postiDisponibiliPranzo}} - Coperti Prenotati:
                        {{this.globalData.totaleCopertiPranzo}} - Coperti rimanenti:
                        {{this.globalData.postiDisponibiliPranzo - this.globalData.totaleCopertiPranzo}}</h3>
                </div>
                <div class="panel-body text-center" style="color:black !important">
                    <div no-lines>
                        <!-- Secondo livello  -->
                        <div class="row">
                            <div class="col-md-1 col-xs-1 col-lg-1 col-sm-1"></div>
                            <div class="col-md-3 col-xs-3 col-lg-3 col-sm-3">
                                <span>
                                    <h3>Nome</h3>
                                </span>
                            </div>
                            <div class="col-md-2 col-xs-2 col-lg-2 col-sm-2">
                                <span>
                                    <h3>Telefono</h3>
                                </span>
                            </div>
                            <div class="col-md-2 col-xs-2 col-lg-2 col-sm-2"><span>
                                    <h3>Ora</h3>
                                </span></div>
                            <div class="col-md-2 col-xs-2 col-lg-2 col-sm-2"><span>
                                    <h3>Coperti</h3>
                                </span></div>
                            <div class="col-md-2 col-xs-2 col-lg-2 col-sm-2"><span>
                                    <h3>Note</h3>
                                </span></div>
                        </div>

                        <div *ngFor="let item of this.globalData.prenotazioniRistPranzo" appSelezioneDinamica
                            class="row well well-sm">

                            <div class="col-md-1 col-xs-1 col-lg-1 col-sm-1 text-left">

                                <a (click)="preparaModificaRistorante(item); " style='cursor: pointer; float: left'
                                    href="" data-toggle="modal"
                                    [attr.data-target]="'#prenotazioneRistoranteModificaModal'">
                                    <span class="fas fa-edit">&nbsp;&nbsp;&nbsp;</span>
                                </a>
                                <a (click)="preparaDeletePrenotazioneRistorante(item)" style='cursor: pointer' href=""
                                    data-toggle="modal" [attr.data-target]="'#deleteRistoranteModal'">
                                    <span style="color: red" class="far fa-trash-alt"></span></a>


                            </div>

                            <div class="col-md-3 col-xs-3 col-lg-3 col-sm-3">

                                <span class="text-item-magazzino">{{item.utente.nome}} {{item.utente.cognome}}</span>

                            </div>
                            <div class="col-md-2 col-xs-2 col-lg-2 col-sm-2"> {{item.utente.telefono}}</div>
                            <div class="col-md-2 col-xs-2 col-lg-2 col-sm-2"> {{item.orario}}</div>
                            <div class="col-md-2 col-xs-2 col-lg-2 col-sm-2">{{item.numeroCoperti}}</div>
                            <div class="col-md-2 col-xs-2 col-lg-2 col-sm-2"> {{item.nota}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Pannello Fascia Oraria: CENA  -->
        <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h3 class="panel-title text-center" style="color: white"> CENA - Coperti disponibili:
                        {{this.globalData.postiDisponibiliCena}} - Coperti Prenotati:
                        {{this.globalData.totaleCopertiCena}} - 
                        Coperti rimanenti: {{this.globalData.postiDisponibiliCena - this.globalData.totaleCopertiCena}}
                    </h3>
                </div>
                <div class="panel-body text-center" style="color:black !important">
                    <div no-lines>
                        <!-- Secondo livello  -->
                        <div class="row">
                            <div class="col-md-1 col-xs-1 col-lg-1 col-sm-1"></div>
                            <div class="col-md-3 col-xs-3 col-lg-3 col-sm-3">
                                <span>
                                    <h3>Nome</h3>
                                </span>
                            </div>
                            <div class="col-md-2 col-xs-2 col-lg-2 col-sm-2">
                                <span>
                                    <h3>Telefono</h3>
                                </span>
                            </div>
                            <div class="col-md-2 col-xs-2 col-lg-2 col-sm-2"><span>
                                    <h3>Ora</h3>
                                </span></div>
                            <div class="col-md-2 col-xs-2 col-lg-2 col-sm-2"><span>
                                    <h3>Coperti</h3>
                                </span></div>
                            <div class="col-md-2 col-xs-2 col-lg-2 col-sm-2"><span>
                                    <h3>Note</h3>
                                </span></div>
                        </div>

                        <div *ngFor="let item of this.globalData.prenotazioniRistCena" appSelezioneDinamica
                            class="row well well-sm">

                            <div class="col-md-1 col-xs-1 col-lg-1 col-sm-1 text-left">

                                <a (click)="preparaModificaRistorante(item); " style='cursor: pointer; float: left'
                                    href="" data-toggle="modal"
                                    [attr.data-target]="'#prenotazioneRistoranteModificaModal'">
                                    <span class="fas fa-edit">&nbsp;&nbsp;&nbsp;</span>
                                </a>
                                <a (click)="preparaDeletePrenotazioneRistorante(item)" style='cursor: pointer' href=""
                                    data-toggle="modal" [attr.data-target]="'#deleteRistoranteModal'">
                                    <span style="color: red" class="far fa-trash-alt"></span></a>


                            </div>

                            <div class="col-md-3 col-xs-3 col-lg-3 col-sm-3">

                                <span class="text-item-magazzino">{{item.utente.nome}} {{item.utente.cognome}}</span>

                            </div>
                            <div class="col-md-2 col-xs-2 col-lg-2 col-sm-2"> {{item.utente.telefono}}</div>
                            <div class="col-md-2 col-xs-2 col-lg-2 col-sm-2"> {{item.orario}}</div>
                            <div class="col-md-2 col-xs-2 col-lg-2 col-sm-2">{{item.numeroCoperti}}</div>
                            <div class="col-md-2 col-xs-2 col-lg-2 col-sm-2"> {{item.nota}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="row hidden-md hidden-lg">
        <div class="col-md-2 col-lg-2 col-xs-2 col-sm-2 hidden-xs hidden-sm"></div>
        <div class="col-md-8 col-lg-8 col-xs-12 col-sm-12" style="position:relative">
            <span (click)="toggleAlertNewBookings()" *ngIf="globalData.showAlertNewBookingsRist"
                style="top: 0; right: 0; position: absolute; margin-right: 25px; margin-top: 10px; font-size: 1.5vh; cursor: pointer;">X</span>
            <alert class="nuoviOrdini" *ngIf="globalData.showAlertNewBookingsRist"
                style="cursor: pointer; width: 800px; height: 600px; font-size: 5.5vh; text-align: center; font-weight: 700; top: 50%; left: 0;"
                (click)="toggleAlertNewBookings()" type="danger">SONO PRESENTI NUOVE PRENOTAZIONI
            </alert>
        </div>

        <!-- Pannello Fascia Oraria: PRANZO -->
        <div class="col-sm-12 col-xs-12">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h3 class="panel-title text-center" style="color: white"> PRANZO - Coperti disponibili:
                        {{this.globalData.postiDisponibiliPranzo}} <br> Coperti Prenotati:
                        {{this.globalData.totaleCopertiPranzo}} <br> Coperti rimanenti:
                        {{this.globalData.postiDisponibiliPranzo - this.globalData.totaleCopertiPranzo}}</h3>
                </div>
                <div class="panel-body text-center" style="color:black !important">
                    <div no-lines>
                        <!-- Secondo livello  -->
                        <div class="row" *ngFor="let item of this.globalData.prenotazioniRistPranzo"
                            appSelezioneDinamica class="row well well-sm">

                            <div class="col-sm-12 col-xs-12">
                                <span>
                                    <a (click)="preparaModificaRistorante(item); " style='cursor: pointer; float: left'
                                        href="" data-toggle="modal"
                                        [attr.data-target]="'#prenotazioneRistoranteModificaModal'">
                                        <span class="fas fa-edit">&nbsp;&nbsp;&nbsp;</span>
                                    </a>
                                    <a (click)="preparaDeletePrenotazioneRistorante(item)"
                                        style='cursor: pointer; float: left' href="" data-toggle="modal"
                                        [attr.data-target]="'#deleteRistoranteModal'">
                                        <span style="color: red" class="far fa-trash-alt"></span></a>
                                </span>
                            </div>

                            <div class="col-sm-12 col-xs-12">
                                <span style=' float: left;'> <b>Nome:</b> {{item.utente.nome}}
                                    {{item.utente.cognome}}</span>

                            </div>

                            <div class="col-sm-12 col-xs-12">
                                <span style=' float: left;'> <b>Telefono:</b>
                                    {{item.utente.telefono}}</span>
                            </div>
                            <div class="col-sm-12 col-xs-12">
                                <span style=' float: left;'> <b>Ora:</b> {{item.orario}} - <b>Coperti:</b>
                                    {{item.numeroCoperti}} </span>

                            </div>

                            <div class="col-sm-12 col-xs-12"
                                *ngIf="item.nota != '' && item.nota != null && item.nota != undefined">
                                <span style=' float: left;'> <b>Note:</b> {{item.nota}}</span>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Pannello Fascia Oraria: CENA  -->
        <div class="col-sm-12 col-xs-12">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h3 class="panel-title text-center" style="color: white"> CENA - Coperti disponibili:
                        {{this.globalData.postiDisponibiliCena}} <br> Coperti Prenotati:
                        {{this.globalData.totaleCopertiCena}} <br> Coperti rimanenti:
                        {{this.globalData.postiDisponibiliCena - this.globalData.totaleCopertiCena}}
                    </h3>
                </div>
                <div class="panel-body text-center" style="color:black !important">
                    <div no-lines>
                        <!-- Secondo livello  -->
                        <div class="row" *ngFor="let item of this.globalData.prenotazioniRistCena" appSelezioneDinamica
                            class="row well well-sm">

                            <div class="col-sm-12 col-xs-12">
                                <span>
                                    <a (click)="preparaModificaRistorante(item); " style='cursor: pointer; float: left'
                                        href="" data-toggle="modal"
                                        [attr.data-target]="'#prenotazioneRistoranteModificaModal'">
                                        <span class="fas fa-edit">&nbsp;&nbsp;&nbsp;</span>
                                    </a>
                                    <a (click)="preparaDeletePrenotazioneRistorante(item)"
                                        style='cursor: pointer; float: left' href="" data-toggle="modal"
                                        [attr.data-target]="'#deleteRistoranteModal'">
                                        <span style="color: red" class="far fa-trash-alt"></span></a>
                                </span>
                            </div>

                            <div class="col-sm-12 col-xs-12">
                                <span style=' float: left;'> <b>Nome:</b> {{item.utente.nome}}
                                    {{item.utente.cognome}}</span>

                            </div>

                            <div class="col-sm-12 col-xs-12">
                                <span style=' float: left;'> <b>Telefono:</b>
                                    {{item.utente.telefono}}</span>
                            </div>
                            <div class="col-sm-12 col-xs-12">
                                <span style=' float: left;'> <b>Ora:</b> {{item.orario}} - <b>Coperti:</b>
                                    {{item.numeroCoperti}} </span>

                            </div>

                            <div class="col-sm-12 col-xs-12"
                                *ngIf="item.nota != '' && item.nota != null && item.nota != undefined">
                                <span style=' float: left;'> <b>Note:</b> {{item.nota}}</span>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>





















    <!-- Modale per aggiungere una prenotazione ristorante  -->

    <div class="modal fade" id="addPrenotazioneRistoranteoModal" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title" id="addPrenotazioneRistoranteoModalLabel">Aggiungi Prenotazione
                        Ristorante </h2>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="justify-content-center align-items-center ">
                        <div *ngIf="!isIdUtentePresente" class='form-inline'
                    style='text-align: left; margin-bottom: 15px;'>
                    <label floating>Selezionare da Anagrafica Clienti? &nbsp;</label>
                    <label class='radio-inline'>
                        <input [(ngModel)]="this.presenteInAnagrafica" name="this.presenteInAnagrafica" type='radio'
                            value='false'>No
                    </label>
                    <label class='radio-inline'>
                        <input [(ngModel)]="this.presenteInAnagrafica" name="this.presenteInAnagrafica" type='radio'
                            value='true'>Si
                    </label>
                </div>
                <div class='form-group'
                *ngIf="!isIdUtentePresente &&  this.presenteInAnagrafica == 'true' ">
                <label style='position: relative; float:left' floating>Filtra clienti:</label><br>
                <button aria-label="Close" class="close" (click)="resetCampiModale()" type="button"
                    style=" position: absolute; top: 12.5%; right: 5%;"><span aria-hidden="true">×</span></button>
                <input type="text" class="form-control"
                    placeholder="Inserire Nome, Numero o E-mail per filtrare la ricerca" [(ngModel)]="filterTemp"
                    (ngModelChange)="debouncerOrdini.next($event)">
                <div *ngIf="filterTemp != null && filterTemp != ''">
                    <label style='position: relative; float:left; margin-top: 5px;' floating>Seleziona il cliente
                        dalla
                        lista:</label><br>
                    <select [(ngModel)]="this.elementoSelezionato" (change)="valorizzaModale()"
                        class="form-control">

                        <option
                            *ngFor="let utente of globalData.listaUtenti | stringFilterAnagrafica: filter; let i = index"
                            value={{i}}>{{utente.cognome}} {{utente.nome}} - Tel: {{utente.telefono}} - Email:
                            {{utente.email}}</option>

                    </select>
                </div>
            </div>

                        <form novalidate [formGroup]="ristoranteForm">
                            <div class='form-inline' style='text-align: left; margin-bottom: 15px;'>
                                <label floating class="text-white modal-modifica-align">Dettagli
                                    Prenotazione:
                                </label><br>
                             
                                <input formControlName="nome"
                                    [class.error1]="!ristoranteForm.controls.nome.valid && ristoranteForm.controls.nome.dirty"
                                    class="form-control mobile-insert-data" placeholder="Nome" type="text" [attr.disabled]="this.presenteInAnagrafica == 'true' ? '' : null"
                                    [(ngModel)]="itemRistorante.nome">
                                <input formControlName="cognome"
                                    [class.error1]="!ristoranteForm.controls.cognome.valid && ristoranteForm.controls.cognome.dirty"
                                    class="form-control mobile-insert-data " placeholder="Cognome" type="text" [attr.disabled]="this.presenteInAnagrafica == 'true' ? '' : null"
                                    [(ngModel)]="itemRistorante.cognome">
                                <div no-lines
                                    *ngIf="( ristoranteForm.get('nome').hasError('minlength') || ristoranteForm.get('nome').hasError('maxlength') || ristoranteForm.get('nome').hasError('pattern') || ristoranteForm.get('nome').hasError('required') ) && ristoranteForm.get('nome').touched">
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('nome').hasError('required') && ristoranteForm.get('nome').touched">
                                        Inserire il nome
                                    </div>
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('nome').hasError('minlength') && ristoranteForm.get('nome').touched">
                                        Lunghezza minima 3 caratteri
                                    </div>
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('nome').hasError('maxlength') && ristoranteForm.get('nome').touched">
                                        La lunghezza &#234; superiore ai 25 caratteri
                                    </div>
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('nome').hasError('pattern') && ristoranteForm.get('nome').touched">
                                        Inserire solo lettere
                                    </div>
                                </div>

                                <div no-lines
                                    *ngIf="( ristoranteForm.get('cognome').hasError('minlength') || ristoranteForm.get('cognome').hasError('maxlength') || ristoranteForm.get('cognome').hasError('pattern') || ristoranteForm.get('cognome').hasError('required') ) && ristoranteForm.get('cognome').touched">
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('cognome').hasError('required') && ristoranteForm.get('cognome').touched">
                                        Inserire il cognome
                                    </div>
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('cognome').hasError('minlength') && ristoranteForm.get('cognome').touched">
                                        Lunghezza minima cognome 2 caratteri
                                    </div>
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('cognome').hasError('maxlength') && ristoranteForm.get('cognome').touched">
                                        La lunghezza &#234; superiore ai 20 caratteri
                                    </div>
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('cognome').hasError('pattern') && ristoranteForm.get('cognome').touched">
                                        Inserire solo lettere
                                    </div>
                                </div>

                            </div>


                            <!-- <div class="form-group">
                            <label floating for="labelElementoBar" class="text-white modal-modifica-align">Orario:
                            </label>
                            <load-timepicker></load-timepicker>
                        </div> -->
                            <div class="form-group">
                                <label>Numero di telefono:</label>
                                <input formControlName="telefono"
                                    [class.error1]="!ristoranteForm.controls.telefono.valid && ristoranteForm.controls.telefono.dirty"
                                    class="form-control" placeholder="Numero Cellulare" type="text" [attr.disabled]="this.presenteInAnagrafica == 'true' ? '' : null"
                                    [(ngModel)]="itemRistorante.telefono">

                                <div no-lines
                                    *ngIf="( ristoranteForm.get('telefono').hasError('minlength') || ristoranteForm.get('telefono').hasError('maxlength') || ristoranteForm.get('telefono').hasError('pattern') || ristoranteForm.get('telefono').hasError('required') ) && ristoranteForm.get('telefono').touched">
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('telefono').hasError('required') && ristoranteForm.get('telefono').touched">
                                        Inserire il numero di telefono del cliente
                                    </div>

                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('telefono').hasError('minlength') && ristoranteForm.get('telefono').touched">
                                        Lunghezza errata: cellulare non valido.
                                    </div>
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('telefono').hasError('pattern') && ristoranteForm.get('telefono').touched">
                                        Inserire solo numeri senza spazi
                                    </div>
                                </div>
                            </div>

                            <label>Data: &nbsp;</label>
                            <ngbd-datepicker-ita-rist-add></ngbd-datepicker-ita-rist-add>
                            <div class='form-inline' style='text-align: left; margin-bottom: 15px;'>

                                <label>Fascia Oraria: &nbsp;</label>
                                <select (change)="resettaOrario()" formControlName="fasciaOraria"
                                    [class.error1]="!ristoranteForm.controls.fasciaOraria.valid && ristoranteForm.controls.fasciaOraria"
                                    [(ngModel)]="itemRistorante.fasciaOraria" class="form-control">
                                    <option value=1>Pranzo</option>
                                    <option value=2>Cena</option>

                                </select>
                                <div no-lines
                                    *ngIf="(ristoranteForm.get('fasciaOraria').hasError('required'))  && ristoranteForm.get('fasciaOraria').touched">
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('fasciaOraria').hasError('required') && ristoranteForm.get('fasciaOraria').touched">
                                        Selezionare la fascia oraria
                                    </div>
                                </div>
                                <label *ngIf="itemRistorante.fasciaOraria != '' && itemRistorante.fasciaOraria != null">
                                    &nbsp; Orario: &nbsp; </label>
                                <select formControlName="orario"
                                    [class.error1]="!ristoranteForm.controls.orario.valid && ristoranteForm.controls.orario"
                                    *ngIf="itemRistorante.fasciaOraria != '' && itemRistorante.fasciaOraria != null"
                                    [(ngModel)]="itemRistorante.orario" class="form-control">

                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="12:00">12:00</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="12:15">12:15</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="12:30">12:30</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="12:45">12:45</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="13:00">13:00</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="13:15">13:15</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="13:30">13:30</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="13:45">13:45</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="14:00">14:00</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="14:15">14:15</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="14:30">14:30</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="19:00">19:00</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="19:15">19:15</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="19:30">19:30</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="19:45">19:45</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="20:00">20:00</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="20:15">20:15</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="20:30">20:30</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="20:45">20:45</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="21:00">21:00</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="21:15">21:15</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="21:30">21:30</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="21:45">21:45</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="22:00">22:00</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="22:15">22:15</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="22:30">22:30</option>

                                </select>
                                <div no-lines
                                    *ngIf="(ristoranteForm.get('orario').hasError('required'))  && ristoranteForm.get('orario').touched">
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('orario').hasError('required') && ristoranteForm.get('orario').touched">
                                        Selezionare l'orario di prenotazione
                                    </div>
                                </div>

                            </div>
                            <div class="form-group">
                                <label floating class="text-white modal-modifica-align">Numero Coperti:
                                </label>
                                <input formControlName="numeroCoperti"
                                    [class.error1]="!ristoranteForm.controls.numeroCoperti.valid && ristoranteForm.controls.numeroCoperti"
                                    [(ngModel)]="itemRistorante.coperti" placeholder="Numero Coperti"
                                    class="form-control" type="number">
                                <div no-lines
                                    *ngIf="(ristoranteForm.get('numeroCoperti').hasError('required'))  && ristoranteForm.get('numeroCoperti').touched">
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('numeroCoperti').hasError('required') && ristoranteForm.get('numeroCoperti').touched">
                                        Selezionare il numero di coperti
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div class="form-group">
                            <label floating class="text- white modal-modifica-align">Note:
                            </label>
                            <textarea style="resize: none;" placeholder="Note" class="form-control"
                                [(ngModel)]="itemRistorante.note"> </textarea>
                        </div>

                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" (click)="resetCampiModale();" class="btn btn-info"
                        data-dismiss="modal">Annulla</button>
                    <button (click)="addPrenotazioneRistorante(itemRistorante)" type="button" data-dismiss="modal"
                        class="btn btn-primary"
                        [disabled]="ristoranteForm.invalid || (globalData.dataAddRistorante == undefined || globalData.dataAddRistorante == '' || globalData.dataAddRistorante == null) ">Salva</button>
                </div>
            </div>
        </div>

    </div>

    <!-- Modale per modificare una prenotazione ristorante  -->
    <div class="modal fade" id="prenotazioneRistoranteModificaModal" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title" id="prenotazioneRistoranteModificaModalLabel">Modifica Prenotazione
                        Ristorante </h2>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="justify-content-center align-items-center ">
                        <form novalidate [formGroup]="ristoranteForm">
                            <div class='form-inline' style='text-align: left; margin-bottom: 15px;'>
                                <label floating class="text-white modal-modifica-align">Dettagli
                                    Prenotazione:
                                </label><br>

                                <input style="width: 50%;" formControlName="nome"
                                    [class.error1]="!ristoranteForm.controls.nome.valid && ristoranteForm.controls.nome.dirty"
                                    class="form-control" placeholder="Nome" type="text"
                                    [(ngModel)]="itemRistorante.nome" [attr.disabled]="true">
                                <input style="width: 50%;" formControlName="cognome"
                                    [class.error1]="!ristoranteForm.controls.cognome.valid && ristoranteForm.controls.cognome.dirty"
                                    class="form-control" placeholder="Cognome" type="text"
                                    [(ngModel)]="itemRistorante.cognome" [attr.disabled]="true">
                                <div no-lines
                                    *ngIf="( ristoranteForm.get('nome').hasError('minlength') || ristoranteForm.get('nome').hasError('maxlength') || ristoranteForm.get('nome').hasError('pattern') || ristoranteForm.get('nome').hasError('required') ) && ristoranteForm.get('nome').touched">
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('nome').hasError('required') && ristoranteForm.get('nome').touched">
                                        Inserire il nome
                                    </div>
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('nome').hasError('minlength') && ristoranteForm.get('nome').touched">
                                        Lunghezza minima 3 caratteri
                                    </div>
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('nome').hasError('maxlength') && ristoranteForm.get('nome').touched">
                                        La lunghezza &#234; superiore ai 25 caratteri
                                    </div>
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('nome').hasError('pattern') && ristoranteForm.get('nome').touched">
                                        Inserire solo lettere
                                    </div>
                                </div>

                                <div no-lines
                                    *ngIf="( ristoranteForm.get('cognome').hasError('minlength') || ristoranteForm.get('cognome').hasError('maxlength') || ristoranteForm.get('cognome').hasError('pattern') || ristoranteForm.get('cognome').hasError('required') ) && ristoranteForm.get('cognome').touched">
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('cognome').hasError('required') && ristoranteForm.get('cognome').touched">
                                        Inserire il cognome
                                    </div>
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('cognome').hasError('minlength') && ristoranteForm.get('cognome').touched">
                                        Lunghezza minima cognome 2 caratteri
                                    </div>
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('cognome').hasError('maxlength') && ristoranteForm.get('cognome').touched">
                                        La lunghezza &#234; superiore ai 20 caratteri
                                    </div>
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('cognome').hasError('pattern') && ristoranteForm.get('cognome').touched">
                                        Inserire solo lettere
                                    </div>
                                </div>

                            </div>


                            <!-- <div class="form-group">
                            <label floating for="labelElementoBar" class="text-white modal-modifica-align">Orario:
                            </label>
                            <load-timepicker></load-timepicker>
                        </div> -->
                            <div class="form-group">
                                <label>Numero di telefono:</label>
                                <input formControlName="telefono"
                                    [class.error1]="!ristoranteForm.controls.telefono.valid && ristoranteForm.controls.telefono.dirty"
                                    class="form-control" placeholder="Numero Cellulare" type="text"
                                    [(ngModel)]="itemRistorante.telefono" [attr.disabled]="true">

                                <div no-lines
                                    *ngIf="( ristoranteForm.get('telefono').hasError('minlength') || ristoranteForm.get('telefono').hasError('maxlength') || ristoranteForm.get('telefono').hasError('pattern') || ristoranteForm.get('telefono').hasError('required') ) && ristoranteForm.get('telefono').touched">
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('telefono').hasError('required') && ristoranteForm.get('telefono').touched">
                                        Inserire il numero di telefono del cliente
                                    </div>

                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('telefono').hasError('minlength') && ristoranteForm.get('telefono').touched">
                                        Lunghezza errata: cellulare non valido.
                                    </div>
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('telefono').hasError('pattern') && ristoranteForm.get('telefono').touched">
                                        Inserire solo numeri senza spazi
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="form-group">
                                    <label floating for="labelElementoBar" class="text-white modal-modifica-align">Orario:
                                    </label>
                                    <load-timepicker></load-timepicker>
                                </div> -->
                            <label>Data: &nbsp;</label>
                            <ngbd-datepicker-ita-rist-edit></ngbd-datepicker-ita-rist-edit>

                            <div class='form-inline' style='text-align: left; margin-bottom: 15px;'>
                                <label>Fascia Oraria: &nbsp;</label>
                                <select (change)="resettaOrario()" formControlName="fasciaOraria"
                                    [class.error1]="!ristoranteForm.controls.fasciaOraria.valid && ristoranteForm.controls.fasciaOraria"
                                    [(ngModel)]="itemRistorante.fasciaOraria" class="form-control">
                                    <option value=1>Pranzo</option>
                                    <option value=2>Cena</option>

                                </select>
                                <div no-lines
                                    *ngIf="(ristoranteForm.get('fasciaOraria').hasError('required'))  && ristoranteForm.get('fasciaOraria').touched">
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('fasciaOraria').hasError('required') && ristoranteForm.get('fasciaOraria').touched">
                                        Selezionare la fascia oraria
                                    </div>
                                </div>
                                <label *ngIf="itemRistorante.fasciaOraria != '' && itemRistorante.fasciaOraria != null">
                                    &nbsp; Orario: &nbsp; </label>
                                <select formControlName="orario"
                                    [class.error1]="!ristoranteForm.controls.orario.valid && ristoranteForm.controls.orario"
                                    *ngIf="itemRistorante.fasciaOraria != '' && itemRistorante.fasciaOraria != null"
                                    [(ngModel)]="itemRistorante.orario" class="form-control" (change)="resettaErrore()">

                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="12:00">12:00</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="12:15">12:15</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="12:30">12:30</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="12:45">12:45</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="13:00">13:00</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="13:15">13:15</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="13:30">13:30</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="13:45">13:45</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="14:00">14:00</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="14:15">14:15</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 1" value="14:30">14:30</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="19:00">19:00</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="19:15">19:15</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="19:30">19:30</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="19:45">19:45</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="20:00">20:00</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="20:15">20:15</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="20:30">20:30</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="20:45">20:45</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="21:00">21:00</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="21:15">21:15</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="21:30">21:30</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="21:45">21:45</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="22:00">22:00</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="22:15">22:15</option>
                                    <option *ngIf="itemRistorante.fasciaOraria == 2" value="22:30">22:30</option>

                                </select>
                                <!--     <div no-lines *ngIf="(ristoranteForm.get('orario').hasError('required'))  && ristoranteForm.get('orario').touched">
                                    <div style="color: red !important" class="error" *ngIf="ristoranteForm.get('orario').hasError('required') && ristoranteForm.get('orario').touched">
                                        Selezionare l'orario di prenotazione
                                    </div>
                                </div> -->

                                <div no-lines *ngIf="mostraErroreOrario">
                                    <div style="color: red !important" class="error">
                                        Selezionare l'orario di prenotazione
                                    </div>
                                </div>


                            </div>
                            <div class="form-group">
                                <label floating class="text-white modal-modifica-align">Numero Coperti:
                                </label>
                                <input formControlName="numeroCoperti"
                                    [class.error1]="!ristoranteForm.controls.numeroCoperti.valid && ristoranteForm.controls.numeroCoperti"
                                    [(ngModel)]="itemRistorante.coperti" placeholder="Numero Coperti"
                                    class="form-control" type="number">
                                <div no-lines
                                    *ngIf="(ristoranteForm.get('numeroCoperti').hasError('required'))  && ristoranteForm.get('numeroCoperti').touched">
                                    <div style="color: red !important" class="error"
                                        *ngIf="ristoranteForm.get('numeroCoperti').hasError('required') && ristoranteForm.get('numeroCoperti').touched">
                                        Selezionare il numero di coperti
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div class="form-group">
                            <label floating for="note" class="text-white modal-modifica-align">Note:
                            </label>
                            <textarea style="resize: none;" [(ngModel)]="itemRistorante.note" placeholder="Note"
                                class="form-control" name="note"> bla bla bla bla bla </textarea>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" (click)="resetCampiModale();" class="btn btn-info"
                        data-dismiss="modal">Annulla</button>
                    <button (click)="modificaPrenotazioneRistorante(itemRistorante)" type="button" data-dismiss="modal"
                        class="btn btn-primary"
                        [disabled]="ristoranteForm.invalid || (globalData.dataEditRistorante == undefined || globalData.dataEditRistorante == '' || globalData.dataEditRistorante == null)">Salva</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Modale per eliminare prenotazione -->

    <div class="modal fade" id="deleteRistoranteModal" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title" id="deleteRistoranteModalLabel">Rimuovi Prenotazione</h2>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="justify-content-center align-items-center well well-sm"
                        style="color: #a94442; background-color: #f2dede; border-color: #ebccd1;">
                        <span> Sei sicuro di voler eliminare la prenotazione di {{itemRistorante.nome}}?</span>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" (click)="resetCampiModale()" class="btn btn-info"
                        data-dismiss="modal">Annulla</button>
                    <button (click)="deletePrenotazioneRistorante(itemRistorante.idPrenotazioneRistorante)"
                        type="button" data-dismiss="modal" class="btn btn-danger">Conferma</button>
                </div>
            </div>
        </div>
    </div>

    <!--   Modale per cambiare la disponibilità dei posti a sedere in una certa data  -->
    <div class="modal fade" id="dispRistoranteModal" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title" id="dispRistoranteModalLabel">Cambia Disponibilità Ristorante</h2>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <label>Data: &nbsp;</label>
                    <ngbd-datepicker-ita-rist-disp></ngbd-datepicker-ita-rist-disp>
                    <form novalidate [formGroup]="itemDisponibilForm">
                        <div class="form-group">
                            <label>Fascia Oraria: &nbsp;</label>
                            <select formControlName="fasciaOraria"
                                [class.error1]="!itemDisponibilForm.controls.fasciaOraria.valid && itemDisponibilForm.controls.fasciaOraria"
                                [(ngModel)]="itemDisponibil.fasciaOraria" class="form-control">
                                <option value='1'>Pranzo</option>
                                <option value='2'>Cena</option>
                            </select>
                        </div>
                        <div no-lines
                            *ngIf="(itemDisponibilForm.get('fasciaOraria').hasError('required'))  && itemDisponibilForm.get('fasciaOraria').touched">
                            <div style="color: red !important" class="error"
                                *ngIf="itemDisponibilForm.get('fasciaOraria').hasError('required') && itemDisponibilForm.get('fasciaOraria').touched">
                                Selezionare la fascia oraria
                            </div>
                        </div>


                        <div class="form-group">
                            <label floating class="text-white modal-modifica-align">Numero Coperti Disponibili:</label>
                            <input formControlName="numeroCoperti"
                                [class.error1]="!itemDisponibilForm.controls.numeroCoperti.valid && itemDisponibilForm.controls.numeroCoperti.dirty"
                                [(ngModel)]="itemDisponibil.numeroCoperti" placeholder="Numero Coperti"
                                class="form-control" type="text" pattern="\d*" maxlength="2">

                        </div>
                        <div no-lines
                            *ngIf="(itemDisponibilForm.get('numeroCoperti').hasError('required'))  && itemDisponibilForm.get('numeroCoperti').touched">
                            <div style="color: red !important" class="error"
                                *ngIf="itemDisponibilForm.get('numeroCoperti').hasError('required') && itemDisponibilForm.get('numeroCoperti').touched">
                                Selezionare il numero posti disponibili
                            </div>
                        </div>
                        <div style="color: red !important" class="error"
                            *ngIf="itemDisponibilForm.get('numeroCoperti').hasError('pattern') && itemDisponibilForm.get('numeroCoperti').touched">
                            Inserire solo numeri senza spazi
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button (click)="resetCampiModale()" type="button" class="btn btn-info"
                        data-dismiss="modal">Annulla</button>
                    <button (click)="cambiaDispRistorante(itemDisponibil)" type="button" data-dismiss="modal"
                        class="btn btn-primary"
                        [disabled]="itemDisponibilForm.invalid || (globalData.dataDispRistorante == undefined || globalData.dataDispRistorante == '' || globalData.dataDispRistorante == null)">Conferma</button>
                </div>
            </div>
        </div>
    </div>
</div>